
export class ResponseModel{

	dataTransacao: Date;
	descricao: string;
	codigoDocumento: string;
	valor: string;
	saldo: string;

	constructor(dataTransacao: Date, descricao: string, codigoDocumento: string, valor: string, saldo: string) {
		this.dataTransacao = dataTransacao;
		this.descricao = descricao;
		this.codigoDocumento = codigoDocumento;
		this.valor = valor;
		this.saldo = saldo;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/export-buttons/response.model.ts